import {StackType} from "./StackTypes";

const StackHorizontal = (props: StackType) => {
    return (
        <div className={`flex-row ${props.wrap ? 'flex-wrap' : ''} ${props.fillHeight ? 'fill-height' : ''} ${props.gap ? props.gap : ''} ${props.align ? props.align : ''} ${props.justify ? props.justify : ''} ${props.extraClass ? props.extraClass: ''} ${props.hide ? 'hide' : ''}`}>
            {props.children}
        </div>
    )
}

export default StackHorizontal;